import { Button } from "@mui/material";
import { ChannelStreamConfigAudioInput } from "../../../__generated__/globalTypes";
import ChannelIngestAudioTrack from "./ChannelIngestAudioTrack";
import { Add } from "@mui/icons-material";
import { v4 } from "uuid";

export interface ChannelStreamConfigAudioInputWithId extends ChannelStreamConfigAudioInput {
    id: string;
}

interface Props {
    tracks: ChannelStreamConfigAudioInputWithId[];
    disabled?: boolean;
    onChangeTracks: (tracks: ChannelStreamConfigAudioInputWithId[]) => void;
}

export default function ChannelIngestAudioTracks({ onChangeTracks, disabled, tracks }: Props): JSX.Element {
    return (
        <div>
            {tracks.map((track, i) => (
                <ChannelIngestAudioTrack
                    pidMandatory={tracks.length > 1}
                    track={track}
                    disabled={disabled}
                    key={`track-${i}`}
                    onRemove={() => onChangeTracks(tracks.filter((tr) => tr.id !== track.id))}
                    onChangeTrack={(track) =>
                        onChangeTracks(
                            tracks.map((tr) => {
                                if (tr.id === track.id) {
                                    return track;
                                } else {
                                    return tr;
                                }
                            }),
                        )
                    }
                />
            ))}
            <div style={{ display: disabled === true ? "none" : "flex", justifyContent: "center" }}>
                <Button
                    startIcon={<Add />}
                    color="secondary"
                    size="small"
                    onClick={() =>
                        onChangeTracks(
                            tracks.concat([
                                {
                                    id: v4(),
                                    label: "",
                                    lang: "",
                                },
                            ]),
                        )
                    }
                >
                    Add
                </Button>
            </div>
        </div>
    );
}
